import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect, useRef } from "react";
import "./quickhash.css";
import Table from "react-bootstrap/Table";
import Axios from "axios";
import swal from "sweetalert";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.min.css";

function Quickhash() {
  const [Shelfsku, setShelfsku] = useState([]);
  const [data2, setData2] = useState([]);
  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [barcode, setBarcode] = useState("");
  const [enteredBarcodesList, setEnteredBarcodesList] = useState([]);
  const [scannedBarcodes, setScannedBarcodes] = useState([]);
  const barcodeInputRef = useRef(null);
  const [selectedCheckboxCount, setSelectedCheckboxCount] = useState(0);
  const [selectedDistributor, setSelectedDistributor] = useState(null);
  const [isInputDisabled, setIsInputDisabled] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getshipment`).then(
      (response) => {
        setData(response.data);
      }
    );
    Axios.get(`${INVENTORY_API_BASE_URL}/getship`).then((response) => {
      const latest30Data = response.data.slice(0, 200);

      const allScannedData = latest30Data
        .map((item) => item.barcodeData.map((barcode) => barcode.scannedData))
        .flat(2);

      setData2(allScannedData);
    });
    Axios.get(`${INVENTORY_API_BASE_URL}/getManageshelf`).then(
      (response) => {
        const shelfData = response.data;

        const allScannedDat = shelfData.map((item) => item.barcodeData).flat(2);

        setShelfsku(allScannedDat);
      }
    );
  }, []);

  const handleCheckboxChange = (orderIndex, itemIndex) => {
    const updatedSelectedRows = [...selectedRows];
    const foundIndex = updatedSelectedRows.findIndex(
      (row) => row.orderIndex === orderIndex && row.itemIndex === itemIndex
    );

    if (foundIndex === -1) {
      updatedSelectedRows.push({ orderIndex, itemIndex });
      setSelectedCheckboxCount(selectedCheckboxCount + 1);
    } else {
      updatedSelectedRows.splice(foundIndex, 1);
      setSelectedCheckboxCount(selectedCheckboxCount);
    }

    setSelectedRows(updatedSelectedRows);

    if (selectedCheckboxCount === 1) {
      window.location.reload();
    }
  };

  const handleBarcodeScanned = async (scannedBarcode) => {
    try {
      const response = await Axios.get(
        `${INVENTORY_API_BASE_URL}/getKey/${scannedBarcode}`
      );
      const key = response.data.key;

      if (key) {
        const selectedRow = selectedRows.find((row) =>
          key.includes(data[row.orderIndex].updatedQuantity[row.itemIndex].sku)
        );

        const isBarcodeAlreadyEntered = enteredBarcodesList.includes(key);
        if (isBarcodeAlreadyEntered) {
          alertify.message("Barcode already exists in the list");
          setBarcode("");
          return;
        }

        const isBarcodeInDatabase = data2.includes(key);
        if (isBarcodeInDatabase) {
          alertify.warning("Barcode already present in Database");
          setBarcode("");
          return;
        }

        const isBarcodeInShelf = Shelfsku.includes(key);
        if (isBarcodeInShelf) {
          alertify.warning("Barcode is in Shelf , No Quick Outbound");
          setBarcode("");
          return;
        }

        if (selectedRow) {
          const selectedItem =
            data[selectedRow.orderIndex].updatedQuantity[selectedRow.itemIndex];

          setSelectedItem(selectedItem);

          const skuExists = selectedRows.some((row) =>
            key.includes(
              data[row.orderIndex].updatedQuantity[row.itemIndex].sku
            )
          );

          if (enteredBarcodesList.length === selectedItem.approvedquantity) {
            alertify.alert("Quantity matched", "Stop scanning.").set({
              onshow: function () {
                setIsInputDisabled(true);
              },
              onclose: function () {
                setIsInputDisabled(false);
              },
            });
            setBarcode("");
            return;
          }

          if (skuExists) {
            setScannedBarcodes([
              ...scannedBarcodes,
              {
                enteredBarcode: key,
              },
            ]);

            setBarcode("");
            setEnteredBarcodesList([...enteredBarcodesList, key]);

            if (
              enteredBarcodesList.length ===
              selectedItem.approvedquantity - 1
            ) {
              alertify.alert("Quantity matched", "Stop scanning.");
              setBarcode("");
              return;
            }

            alertify.success("Barcode scanned successfully");
          } else {
            alertify.error("SKU not found in scanned barcode");
            setBarcode("");
          }
        } else {
          alertify.error("SKU not found in scanned barcode");
          setBarcode("");
        }
      } else {
        alertify.error("Key not found for the given value");
        setBarcode("");
      }
    } catch (error) {
      console.error("Error fetching key:", error);
    }
  };

  useEffect(() => {
    if (barcodeInputRef.current) {
      barcodeInputRef.current.focus();
    }

    const handleClickOutsideInput = (event) => {
      if (
        barcodeInputRef.current &&
        !barcodeInputRef.current.contains(event.target)
      ) {
        barcodeInputRef.current.focus();
      }
    };

    document.addEventListener("click", handleClickOutsideInput);

    return () => {
      document.removeEventListener("click", handleClickOutsideInput);
    };
  }, []);

  function handleSubmit() {
    setIsLoading(true);

    if (enteredBarcodesList.length === 0) {
      swal("Error", "Please add a barcode first", "error");
      return;
    }

    if (enteredBarcodesList.length < selectedItem.approvedquantity) {
      alertify.error("Scanned Qty is less than Approved Qty");
      return;
    }

    const selectedShipmentIDsString = selectedRows
      .map((row) => data[row.orderIndex].shipmentid)
      .join(", ");

    const selectedDistributorNamesString = selectedRows
      .map((row) => data[row.orderIndex].distributorName)
      .join(", ");

    const orderNumbers = selectedRows
      .map((row) => data[row.orderIndex].orderid)
      .join(", ");
    const batchIDs = selectedRows
      .map((row) => data[row.orderIndex].updatedQuantity[row.itemIndex].batchid)
      .join(", ");
    const titles = selectedRows
      .map((row) => data[row.orderIndex].updatedQuantity[row.itemIndex].title)
      .join(", ");

    const dataToSend = {
      orderno: orderNumbers,
      barcodeData: enteredBarcodesList,
      count: enteredBarcodesList.length,
      BatchID: batchIDs,
      Title: titles,
    };

    const postResult = Axios.post(
      `${INVENTORY_API_BASE_URL}/scanInbound`,
      dataToSend
    );

    const shipmentDataToPost = {
      totalCount: enteredBarcodesList.length,
      totalBoxes: 1,
      totalWeight: null,
      barcodeData: {
        BoxNo: 1,
        scannedData: enteredBarcodesList,
        count: enteredBarcodesList.length,
        OrderNum: selectedShipmentIDsString,
        DistributorName: selectedDistributorNamesString,
      },
    };

    const postResult1 = Axios.post(
      `${INVENTORY_API_BASE_URL}/createshipment`,
      shipmentDataToPost
    );

    postResult1
      .then(() => {
        setIsLoading(false);
        swal({
          title: "Outbound completed",
          text: "",
          icon: "success",
        }).then(() => {
          window.location.reload();
        });
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error creating shipment:", error);
      });
  }

  const getUniqueFilteredDistributors = () => {
    const filteredDistributors = data
      .filter((order) => order.dispatchthrough === "Pinnacle(Quick)")
      .map((order) => order.distributorName);

    const uniqueFilteredDistributors = [...new Set(filteredDistributors)];
    return uniqueFilteredDistributors;
  };

  const pageSize = 10;
  const filteredQuickhashRows = data.flatMap((order, orderIndex) =>
    order.dispatchthrough === "Pinnacle(Quick)" &&
    (!selectedDistributor || order.distributorName === selectedDistributor)
      ? order.updatedQuantity.map((item, itemIndex) => ({
          order,
          orderIndex,
          item,
          itemIndex,
        }))
      : []
  );
  const totalPages = Math.max(1, Math.ceil(filteredQuickhashRows.length / pageSize));
  const currentPageRows = filteredQuickhashRows.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const firstVisibleRow =
    filteredQuickhashRows.length === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const lastVisibleRow = Math.min(
    currentPage * pageSize,
    filteredQuickhashRows.length
  );

  return (
    <main className="quickhash-page">
      <div className="quickhash-page__inner">
        <header className="quickhash-hero">
          <div>
            <p className="quickhash-eyebrow">
              <span aria-hidden="true" />
              WAREHOUSE OPERATIONS / OUTBOUND
            </p>
            <h1>Quick outbound</h1>
            <p>Scan and prepare barcodes for eligible Pinnacle Quick orders.</p>
          </div>
          <div className="quickhash-hero__count" aria-live="polite">
            <strong>{filteredQuickhashRows.length.toLocaleString()}</strong>
            <span>eligible items</span>
          </div>
        </header>

        <section className="quickhash-filter-card" aria-labelledby="quickhash-filter-title">
          <div className="quickhash-filter-card__copy">
            <span className="quickhash-filter-icon" aria-hidden="true">⌕</span>
            <div>
              <h2 id="quickhash-filter-title">Choose a distributor</h2>
              <p>Filter the order list or keep All selected to see every eligible order.</p>
            </div>
          </div>
          <div className="quickhash-filter-control">
            <label htmlFor="quickhash-distributor">Distributor</label>
            <select
              id="quickhash-distributor"
              value={selectedDistributor || ""}
              onChange={(event) => {
                setSelectedDistributor(event.target.value || null);
                setCurrentPage(1);
              }}
            >
              <option value="">All distributors</option>
              {getUniqueFilteredDistributors().map((distributor) => (
                <option key={distributor} value={distributor}>
                  {distributor}
                </option>
              ))}
            </select>
          </div>
        </section>

        <section className="quickhash-panel" aria-labelledby="quickhash-orders-title">
          <div className="quickhash-panel__heading">
            <div>
              <h2 id="quickhash-orders-title">Pinnacle Quick orders</h2>
              <p>Select the order item you are preparing, then scan its approved quantity.</p>
            </div>
            <span className="quickhash-panel__tag">10 items per page</span>
          </div>

          <div className="quickhash-table-wrap">
            <Table className="quickhash-table" aria-label="Pinnacle Quick order items">
              <thead>
                <tr>
                  <th scope="col">Shipment ID</th>
                  <th scope="col">Distributor</th>
                  <th scope="col">PO date</th>
                  <th scope="col">Select</th>
                  <th scope="col">Title</th>
                  <th scope="col">Medium</th>
                  <th scope="col">SKU</th>
                  <th scope="col">Approved qty</th>
                </tr>
              </thead>
              <tbody>
                {currentPageRows.length === 0 ? (
                  <tr>
                    <td className="quickhash-empty-cell" colSpan={8}>
                      No Quick outbound order items match this filter.
                    </td>
                  </tr>
                ) : (
                  currentPageRows.map(({ order, orderIndex, item, itemIndex }) => {
                    const isSelected = selectedRows.some(
                      (row) =>
                        row.orderIndex === orderIndex && row.itemIndex === itemIndex
                    );
                    return (
                      <tr
                        key={`${order.orderid}-${itemIndex}`}
                        className={isSelected ? "is-selected" : ""}
                      >
                        <td data-label="Shipment ID" className="quickhash-order-id">
                          {order.shipmentid}
                        </td>
                        <td data-label="Distributor" title={order.distributorName}>
                          {order.distributorName}
                        </td>
                        <td data-label="PO date">{order.ApprovalDate}</td>
                        <td data-label="Select" className="quickhash-select-cell">
                          <input
                            type="checkbox"
                            aria-label={`Select ${item.sku} order item`}
                            onChange={() => handleCheckboxChange(orderIndex, itemIndex)}
                            checked={isSelected}
                          />
                        </td>
                        <td data-label="Title" className="quickhash-title" title={item.title}>
                          {item.title}
                        </td>
                        <td data-label="Medium">{item.Medium}</td>
                        <td data-label="SKU" className="quickhash-sku">{item.sku}</td>
                        <td data-label="Approved qty" className="quickhash-quantity">
                          <span>{item.approvedquantity}</span>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>

          <div className="quickhash-pagination">
            <p aria-live="polite">
              Showing <strong>{firstVisibleRow}–{lastVisibleRow}</strong> of{" "}
              <strong>{filteredQuickhashRows.length}</strong> items
            </p>
            <nav className="quickhash-pagination__controls" aria-label="Order list pagination">
              <button
                type="button"
                onClick={() => setCurrentPage((page) => Math.max(1, page - 1))}
                disabled={currentPage <= 1}
              >
                <span aria-hidden="true">←</span>
                Previous
              </button>
              <span className="quickhash-pagination__page">
                Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
              </span>
              <button
                type="button"
                onClick={() =>
                  setCurrentPage((page) => Math.min(totalPages, page + 1))
                }
                disabled={currentPage >= totalPages}
              >
                Next
                <span aria-hidden="true">→</span>
              </button>
            </nav>
          </div>
        </section>

        <section className="quickhash-scan-section" aria-labelledby="quickhash-scan-title">
          <div className="quickhash-scan-section__heading">
            <div>
              <p className="quickhash-eyebrow">
                <span aria-hidden="true" />
                BARCODE CAPTURE
              </p>
              <h2 id="quickhash-scan-title">Scan selected items</h2>
              <p>Barcodes are checked against the selected SKU, shelves, and previous outbound scans.</p>
            </div>
            <span className="quickhash-scan-section__count">
              {selectedRows.length.toLocaleString()} selected
            </span>
          </div>

          {selectedRows.length === 0 ? (
            <div className="quickhash-scan-empty">
              <span aria-hidden="true">⌁</span>
              <div>
                <strong>Select an order item to start scanning</strong>
                <p>The barcode entry area will appear here after you select an item above.</p>
              </div>
            </div>
          ) : (
            <div className="quickhash-selected-list">
              {data.map((order, orderIndex) =>
                order.updatedQuantity.map(
                  (item, itemIndex) =>
                    selectedRows.some(
                      (row) =>
                        row.orderIndex === orderIndex && row.itemIndex === itemIndex
                    ) && (
                      <article
                        className="quickhash-selected-card"
                        key={`${orderIndex}-${itemIndex}`}
                      >
                        <div className="quickhash-selected-card__header">
                          <div>
                            <span className="quickhash-selected-card__eyebrow">
                              {order.shipmentid} · {order.distributorName}
                            </span>
                            <h3 title={item.title}>{item.title}</h3>
                            <p>SKU <strong>{item.sku}</strong></p>
                          </div>
                          <span className="quickhash-selected-card__qty">
                            {item.approvedquantity} approved
                          </span>
                        </div>
                        <label htmlFor={`quickhash-barcode-${orderIndex}-${itemIndex}`}>
                          Scan or enter a barcode
                        </label>
                        <input
                          id={`quickhash-barcode-${orderIndex}-${itemIndex}`}
                          className="quickhash-barcode-input"
                          type="text"
                          ref={barcodeInputRef}
                          value={barcode}
                          placeholder="Scan barcode, then press Enter"
                          autoComplete="off"
                          onChange={(e) => setBarcode(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleBarcodeScanned(barcode);
                            }
                          }}
                          disabled={isInputDisabled}
                        />
                        <div className="quickhash-barcode-summary">
                          <h4>
                            Entered barcodes
                            <span>{enteredBarcodesList.length.toLocaleString()}</span>
                          </h4>
                          {enteredBarcodesList.length === 0 ? (
                            <p className="quickhash-barcode-summary__empty">
                              Scanned barcodes will appear here.
                            </p>
                          ) : (
                            <ul className="quickhash-barcode-list">
                              {enteredBarcodesList.map((barcodeValue, index) => (
                                <li key={index}>
                                  <span>{String(index + 1).padStart(2, "0")}</span>
                                  <code>{barcodeValue}</code>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </article>
                    )
                )
              )}
            </div>
          )}

          {isLoading && (
            <div className="quickhash-loading" role="status">
              <span aria-hidden="true" />
              Completing outbound…
            </div>
          )}

          <footer className="quickhash-submit-row">
            <p>Scan the full approved quantity before saving the outbound shipment.</p>
            <button
              className="quickhash-submit-button"
              type="button"
              onClick={handleSubmit}
            >
              Save scanned ID
              <span aria-hidden="true">→</span>
            </button>
          </footer>
        </section>
      </div>
    </main>
  );
}

export default Quickhash;
